"use strict";

var _interopRequireWildcard = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.set.difference.v2.js");
require("core-js/modules/es.set.intersection.v2.js");
require("core-js/modules/es.set.is-disjoint-from.v2.js");
require("core-js/modules/es.set.is-subset-of.v2.js");
require("core-js/modules/es.set.is-superset-of.v2.js");
require("core-js/modules/es.set.symmetric-difference.v2.js");
require("core-js/modules/es.set.union.v2.js");
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
var _lifehikesInitData = require("@/lifehikes-init-data");
var _log = require("@/utils/log");
var _cookie = require("@/utils/cookie");
var _resource = require("@/api/resource");
var _publicFile = require("@/api/publicFile");
var _moment = _interopRequireDefault(require("moment"));
var _ga = require("@/utils/ga");
var _utils = require("@/utils");
var Constants = _interopRequireWildcard(require("@lifehikes/lh-js-common-lib"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ResourceDetail',
  components: {
    Tinymce: _Tinymce.default
  },
  props: {
    displayType: {
      type: String,
      default: 'create'
    }
  },
  data() {
    return {
      validImageExtension: _lifehikesInitData.validImageExtension,
      fullscreenloading: false,
      typeList: _lifehikesInitData.resourceType,
      subtypeList: ['event-resource', 'learn-grow-content', 'bubble-coach-content'],
      icons: ['doc', 'doc-tips', 'video', 'trail-guide'],
      iconNames: {
        'doc': 'Document',
        'doc-tips': 'Document tips',
        'video': 'Video',
        'trail-guide': 'Trail Guide'
      },
      mimeList: _lifehikesInitData.resourceMimeType,
      createButtonDisable: false,
      showThumbnailUploadErrMsg: false,
      file: null,
      thumbnailFile: null,
      tagInputValue: '',
      /* for tags component user */
      tagInputVisible: false,
      /* for tags component user */
      loggedInUserTenants: [],
      resourceForm: {
        id: '',
        type: '',
        category: 'event-resource',
        free: false,
        title: '',
        description: '',
        thumbnailUrl: '',
        icon: 'doc',
        filename: '',
        mimeType: '',
        shareable: true,
        isPublished: true,
        tags: [],
        metadata: {
          tenants: []
        }
      }
    };
  },
  computed: {
    isRichText() {
      return this.resourceForm.type === 'text';
    },
    contentShortLength() {
      return this.postForm.content_short.length;
    },
    isRoot() {
      const user = (0, _cookie.getCookie)('ROLES');
      return user.indexOf('root') >= 0;
    },
    isAdminOrRoot() {
      const roles = this.$store.getters.roles;
      return roles.includes(Constants.USER_ROLE_ADMIN) || roles.includes(Constants.USER_ROLE_ROOT);
    },
    tenantOptions() {
      // Create a set to avoid duplicates
      const tenants = new Set(this.loggedInUserTenants);
      if (this.resourceForm.metadata && this.resourceForm.metadata.tenants) {
        if (Array.isArray(this.resourceForm.metadata.tenants)) {
          this.resourceForm.metadata.tenants.forEach(t => tenants.add(t));
        } else {
          tenants.add(this.resourceForm.metadata.tenants);
        }
      }
      return Array.from(tenants);
    }
  },
  created() {
    if (this.displayType === 'edit') {
      this.getResource();
    } else {
      // this.fullscreenloading = true
      /* binding data */
      // this.fullscreenloading = false
    }
    if (this.$store.getters.userMetadata && this.$store.getters.userMetadata.tenants) {
      this.loggedInUserTenants = this.$store.getters.userMetadata.tenants;
    }
  },
  methods: {
    getTenantLabel: _utils.getTenantLabel,
    doAddSave() {
      this.fullscreenloading = true;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const oEmail = (0, _cookie.getCookie)('EMAIL');

      /* remove the mime if no file is attach */
      if (this.resourceForm.filename === '') {
        delete this.resourceForm.filename;
        delete this.resourceForm.mimeType;
      }
      const payload = this.resourceForm;
      payload.status = this.resourceForm.isPublished ? 'published' : 'archived';

      // validate tenants
      if (this.loggedInUserTenants && this.loggedInUserTenants.length > 0) {
        if (!this.resourceForm.metadata.tenants || this.resourceForm.metadata.tenants.length === 0) {
          this.fullscreenloading = false;
          (0, _log.displayPopupMessage)('Please select at least one tenant', 'error');
          return;
        }
      }
      (0, _resource.createResource)(token, payload).then(response => {
        const data = response.data;
        const resourceId = data.id;
        (0, _log.showDebugLog)('Resource-createResource-API-response', data);
        const url = typeof data.upload === 'undefined' ? '' : data.upload.url;
        this.resourceForm.id = typeof data.id === 'undefined' ? '' : data.id;
        this.resourceForm.free = typeof data.free === 'undefined' ? false : data.free;
        this.resourceForm.type = typeof data.type === 'undefined' ? '' : data.type;
        this.resourceForm.title = typeof data.title === 'undefined' ? '' : data.title;
        this.resourceForm.description = typeof data.description === 'undefined' ? '' : data.description;
        this.resourceForm.thumbnailUrl = typeof data.thumbnailUrl === 'undefined' ? '' : data.thumbnailUrl;
        this.resourceForm.filename = typeof data.filename === 'undefined' ? '' : data.filename;
        this.resourceForm.mimeType = typeof data.mimeType === 'undefined' ? '' : data.mimeType;
        this.resourceForm.tags = typeof data.tags === 'undefined' ? '' : data.tags;
        this.resourceForm.shareable = typeof data.shareable === 'undefined' ? false : data.shareable;
        this.resourceForm.isPublished = data.status === 'published';
        this.resourceForm.category = typeof data.category === 'undefined' ? false : data.category;
        this.resourceForm.icon = typeof data.category === 'undefined' ? false : data.icon;
        if (url && this.file) {
          this.uploadS3File(url, resourceId, token);
        } else {
          this.createButtonDisable = true;
          this.fullscreenloading = false;
          const msg = this.$i18n.t('otrResource.successMsg');
          (0, _log.displayPopupMessage)(msg, 'success');
          (0, _ga.writeGaEvent)(this, 'Resource', `${_lifehikesInitData.userEvent.resource.create}`, oEmail, `Resource ID: ${this.resourceForm.id}`);
          // this.$message({ type: 'success', showClose: true, message: 'Resource created successfully' })
        }
      }).catch(error => {
        (0, _log.showDebugLog)('Resource-createResource-API-error', error);
        this.fullscreenloading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    doSave() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const oEmail = (0, _cookie.getCookie)('EMAIL');
      const id = typeof this.$route.params.id === 'undefined' ? this.resourceForm.id : this.$route.params.id;
      this.fullscreenloading = true;

      /* remove the mime if no file is attach */
      if (this.resourceForm.filename === '') {
        delete this.resourceForm.filename;
        delete this.resourceForm.mimeType;
      }
      const payload = this.resourceForm;
      payload.status = this.resourceForm.isPublished ? 'published' : 'archived';

      // validate tenants
      if (this.loggedInUserTenants && this.loggedInUserTenants.length > 0) {
        if (!this.resourceForm.metadata.tenants || this.resourceForm.metadata.tenants.length === 0) {
          this.fullscreenloading = false;
          (0, _log.displayPopupMessage)('Please select at least one tenant', 'error');
          return;
        }
      }
      // console.log('Update form data', this.resourceForm.tags)

      (0, _resource.updateResourceById)(token, id, payload).then(response => {
        // console.log('Update-Resource-API', response.data)

        // this.fullscreenloading = false
        const data = response.data;
        const resourceId = data.id;
        const url = typeof data.upload === 'undefined' ? '' : data.upload.url;
        this.resourceForm.id = typeof data.id === 'undefined' ? '' : data.id;
        this.resourceForm.free = typeof data.free === 'undefined' ? false : data.free;
        this.resourceForm.type = typeof data.type === 'undefined' ? '' : data.type;
        this.resourceForm.title = typeof data.title === 'undefined' ? '' : data.title;
        this.resourceForm.description = typeof data.description === 'undefined' ? '' : data.description;
        this.resourceForm.thumbnailUrl = typeof data.thumbnailUrl === 'undefined' ? '' : data.thumbnailUrl;
        this.resourceForm.filename = typeof data.filename === 'undefined' ? '' : data.filename;
        this.resourceForm.mimeType = typeof data.mimeType === 'undefined' ? '' : data.mimeType;
        this.resourceForm.tags = typeof data.tags === 'undefined' ? '' : data.tags;
        this.resourceForm.shareable = typeof data.shareable === 'undefined' ? false : data.shareable;
        this.resourceForm.isPublished = data.status === 'published';
        this.resourceForm.category = typeof data.category === 'undefined' ? '' : data.category;
        this.resourceForm.icon = typeof data.icon === 'undefined' ? '' : data.icon;
        if (url && this.file) {
          this.uploadS3File(url, resourceId, token);
        } else {
          this.createButtonDisable = true;
          this.fullscreenloading = false;
          const msg = this.$i18n.t('otrResource.updateOKMsg');
          (0, _log.displayPopupMessage)(msg, 'success');
          (0, _ga.writeGaEvent)(this, 'Resource', `${_lifehikesInitData.userEvent.resource.edit}`, oEmail, `Resource ID: ${this.resourceForm.id}`);
        }
      }).catch(error => {
        (0, _log.showDebugLog)('Resource-GetResource-API-Error', error);
        this.fullscreenloading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    doBack() {
      this.$router.push('/resources/index');
    },
    uploadS3File(url, resourceId, token) {
      // upload file to S3
      (0, _resource.uploadToS3)(this.file, url).then(response => {
        // console.log('S3 URL', url)
        // console.log('Resource-uploadToS3-API', response.data)

        // Sync the data afer upload to S3
        (0, _resource.syncResource)(token, resourceId).then(response => {
          this.createButtonDisable = true;
          this.fullscreenloading = false;
          const msg = this.$i18n.t('otrResource.successMsg');
          (0, _log.displayPopupMessage)(msg, 'success');
        }).catch(error => {
          (0, _log.showDebugLog)('Resource-uploadToS3Sync-API-API-error', error);
          this.fullscreenloading = false;
          (0, _log.displayPopupMessage)(error, 'error');
        });
      }).catch(error => {
        (0, _log.showDebugLog)('Resource-uploadTS3File-API-API-error', error);
        // console.log('Resource-uploadTS3File-API-API-error-original', error)
        this.fullscreenloading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    doThumbnailUpload() {
      (0, _log.showDebugLog)('Debug-uploadIconFile', this.thumbnailFile);
      this.fullscreenloading = true;
      const thumbnailIconForm = new FormData();
      thumbnailIconForm.append('file', this.thumbnailFile);
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      (0, _publicFile.uploadFile)(token, thumbnailIconForm).then(response => {
        this.fullscreenloading = false;
        this.showThumbnailUploadErrMsg = false;
        this.resourceForm.thumbnailUrl = response.data.location;
      }).catch(error => {
        (0, _log.showDebugLog)('upload-resourceThumbnail-icon-api-error', error);
        this.fullscreenloading = false;
        this.showThumbnailUploadErrMsg = true;
      });
    },
    chooseFile(e) {
      (0, _log.showDebugLog)('Debug-uploadTrainingImg', e.target.files[0]);
      this.file = e.target.files[0];
      this.resourceForm.filename = typeof this.file.name === 'undefined' ? '' : this.file.name;
      this.resourceForm.mimeType = typeof this.file.type === 'undefined' ? '' : this.file.type;
      (0, _log.showDebugLog)('choose file', this.file);
    },
    chooseThumbnailFile(e) {
      if (e.target.files.length > 0) {
        (0, _log.showDebugLog)('Debug-uploadTrainingImg', e.target.files[0]);
        if (e.target.files[0].size <= 1048576) {
          this.thumbnailFile = e.target.files[0];
        } else {
          (0, _log.displayPopupMessage)(this.$i18n.t('otrTraining.imageLimit'), 'error');
          this.$refs.thumbfile.value = '';
        }
      }
    },
    getResource() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const id = typeof this.$route.params.id === 'undefined' ? this.resourceForm.id : this.$route.params.id;
      this.fullscreenloading = true;
      (0, _resource.getResourceById)(token, id).then(response => {
        this.fullscreenloading = false;
        (0, _log.showDebugLog)('getResourceId-API', response.data);
        const data = response.data;
        this.resourceForm.id = typeof data.id === 'undefined' ? '' : data.id;
        this.resourceForm.free = typeof data.free === 'undefined' ? false : data.free;
        this.resourceForm.type = typeof data.type === 'undefined' ? '' : data.type;
        this.resourceForm.title = typeof data.title === 'undefined' ? '' : data.title;
        this.resourceForm.description = typeof data.description === 'undefined' ? '' : data.description;
        this.resourceForm.thumbnailUrl = typeof data.thumbnailUrl === 'undefined' ? '' : data.thumbnailUrl;
        this.resourceForm.filename = typeof data.filename === 'undefined' ? '' : data.filename;
        this.resourceForm.tags = typeof data.tags === 'undefined' ? '' : data.tags;
        this.resourceForm.mimeType = typeof data.mimeType === 'undefined' ? '' : data.mimeType;
        this.resourceForm.shareable = typeof data.shareable === 'undefined' ? false : data.shareable;
        this.resourceForm.isPublished = data.status === 'published';
        this.resourceForm.category = typeof data.category === 'undefined' ? '' : data.category;
        this.resourceForm.icon = typeof data.icon === 'undefined' ? '' : data.icon;
        if (data.metadata) {
          if (data.metadata.tenants) {
            this.resourceForm.metadata.tenants = Array.isArray(data.metadata.tenants) ? data.metadata.tenants : [data.metadata.tenants];
          } else if (data.metadata.tenant) {
            this.resourceForm.metadata.tenants = [data.metadata.tenant];
          }
        }
      }).catch(error => {
        (0, _log.showDebugLog)('Resource-GetResource-API-Error', error);
        this.fullscreenloading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    /* for tag component use */
    handleClose(tag) {
      this.resourceForm.tags.splice(this.resourceForm.tags.indexOf(tag), 1);
    },
    handleTagInputConfirm() {
      const inputValue = this.tagInputValue;
      if (inputValue && this.resourceForm.tags.indexOf(inputValue) < 0) {
        this.resourceForm.tags.push(inputValue);
      }
      this.tagInputVisible = false;
      this.tagInputValue = '';
    },
    showTagInput() {
      this.tagInputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    }
  }
};